/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_CHESTTIME = 24;

Mission.REGISTRATIONS.set(Mission.TYPE_CHESTTIME, () => ({
    ...BaseMissionData(),
    available: cleverapps.config.availables.CHESTTIME_MISSION,
    logic: ChestTime,
    name: "ChestTime",
    duration: "1 day",
    packCooldown: "3 hours",
    semaphore: Mission.SEMAPHORE_SECONDARY,
    bundle: "chesttime",
    sideBarJson: bundles.sidebar.jsons.chesttime_icon_json,
    view: ChestTimeMissionWindow,
    startWindow: ChestTimeMissionWindow,
    finishWindow: ChestTimeMissionWindow
}));
